'use client'

import { Benefits } from '@/root/src/components/Auth/Benefits'
import { Form } from '@/root/src/components/Auth/Form'
import { Suspense } from 'react'

export default function Auth() {
    return (
        <div className="min-h-screen flex overflow-y-auto">
            <Suspense fallback={null}>
                {/* Left Side - Benefits */}
                <Benefits />
                {/* Right Side - Form */}
                <Form />
            </Suspense>
        </div>
    )
}
